export default {
    SET_PATIENT_HEALTH_DATA(state, payload) {
        state.patientHealthData = payload;
    }
};
